import { gql } from "@apollo/client";

export const getTeamsForInputs = gql`
    query GetTeamsForInputs {
        getTeams {
            id
            name
        }
    }
`;
